module.exports = __webpack_public_path__ + "media/images/flags/4x3/gtm-f6b8c0f12ec01638e441087bac157850.svg";